import axios, { API_URL } from '../../services/axios';
import { NetworkContext } from '../../types/network';
import { AppThunk } from '../store';
import { setLoading, setViewings, setError, SaleType } from './viewings.slice';

type OpenViewingSearch = (
  date?: string,
  type?: SaleType,
  t?: number | null,
  imageLocator?: string,
  ctx?: NetworkContext,
) => AppThunk<Promise<boolean>>;

export const openViewings: OpenViewingSearch = (date, type, t, imageLocator, ctx) => async (dispatch) => {
  dispatch(setLoading(true));

  const term = t || undefined;

  const saleType = type || 1;

  try {
    const res = await axios(
      {
        url: `${API_URL}/open-viewings`,
        params: {
          date,
          saleType,
          term,
          imageLocator,
        },
      },
      dispatch,
      ctx,
    );

    dispatch(
      setViewings({
        data: res.data,
        loading: false,
        date,
        saleType,
        term,
      }),
    );
    return true;
  } catch (err: any) {
    dispatch(setError(err));
    return false;
  }
};

export default { openViewings };
